export default {
  'modal': {
    'create': {
      'title': 'Create a manager'
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/manager.js